export default __webpack_public_path__ + "static/ProValue_6@992-ff98ab81abab471c3a578c8c76c42df2.png";